
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import MonthRevenueContributionNumberDisplayer from '@/components/reports-v3/components/codedWidgets/agent/AgentMtdRevenueContributionNumberDisplayer.vue';
import YTDSalesNumberDisplayer from '@/components/reports-v3/components/codedWidgets/agent/Agent12MonthsSalesNumberDisplayer.vue';
import YTDSalesProfitNumberDisplayer from '@/components/reports-v3/components/codedWidgets/agent/AgentYtdSalesProfitNumberDisplayer.vue';
import YTDRevenueContributionNumberDisplayer from '@/components/reports-v3/components/codedWidgets/agent/AgentYtdRevenueContributionNumberDisplayer.vue';
import MonthSalesNumberDisplayer from '@/components/reports-v3/components/codedWidgets/agent/AgentSalesNumberDisplayer.vue';
import MonthSalesProfitNumberDisplayer from '@/components/reports-v3/components/codedWidgets/agent/AgentSalesProfitNumberDisplayer.vue';
import AgentSalesAnalysisTreeMap from '@/components/reports-v3/components/codedWidgets/agent/AgentSalesAnalysisTreeMap.vue';
import IndividualAgentSalesMetricTable from '@/components/reports-v3/components/codedWidgets/agent/AgentSalesMetricsTable.vue';
import SalesTrendBarLineChart from '@/components/reports-v3/components/codedWidgets/agent/AgentSalesTrendLineChart.vue';
import LastSync from '@/components/LastSync.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import moment from 'moment';
import DateFilter from '@/components/reports-v3/components/filters/DateFilter.vue';
import gdbx from '@/store/modules/gdbx';
import SelectFilter from '@/components/reports-v3/components/filters/SelectFilter.vue';
import { ValueText } from '@/store/models.def';
import Message from 'primevue/message';
import Divider from 'primevue/divider';
import ProjectSelectFilter from '@/components/reports-v3/components/filters/ProjectSelectFilter.vue';

@Component({
	components: {
        ProjectSelectFilter,
		MonthSalesNumberDisplayer,
		MonthRevenueContributionNumberDisplayer,
		YTDSalesNumberDisplayer,
		YTDSalesProfitNumberDisplayer,
		YTDRevenueContributionNumberDisplayer,
		MonthSalesProfitNumberDisplayer,
		AgentSalesAnalysisTreeMap,
		IndividualAgentSalesMetricTable,
		StickyFilterContainer,
		DateFilter,
		LastSync,
		SelectFilter,
		SalesTrendBarLineChart,
		Message,
		Divider,
	},
})
export default class SalesIndividualAgent extends Vue {
	public selectedDay: number = moment().endOf('month').endOf('day').valueOf();
	public defaultAgent: string = '----';
	public lastInvoiceDate: number = 0;
	public customerCount: number = 0;
    public selectedDocProjects = [];
    public selectedDTLProjects = [];


	public mounted() {
		this.track();
	}

	public track() {
		this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
		this.$ga.page(router);
	}

	public receivedCustomerCount(value: number) {
		this.customerCount = value;
	}

	public receivedLastInvoiceDate(value: number) {
		this.lastInvoiceDate = value;
	}

	public get lastInvoiceDateFormatted(): string {
		if (!this.lastInvoiceDate) {
			return '-';
		}
		return moment(this.lastInvoiceDate).format('DD MMM YYYY');
	}

	public get selectedAsOfDate() {
		return moment(this.selectedDay).endOf('month').valueOf();
	}

	public get selectedCurrentMonthRange(): [number, number] {
		return [
			moment(this.selectedDay).startOf('month').valueOf(),
			moment(this.selectedDay).endOf('month').valueOf(),
		];
	}

	public get selectedDateRange(): [number, number] {
		return [
			moment(this.selectedDay).startOf('year').valueOf(),
			moment(this.selectedDay).endOf('year').valueOf(),
		];
	}

	public get selectedYearToDateRange(): [number, number] {
		return [
			moment(this.selectedDay).startOf('year').valueOf(),
			moment(this.selectedDay).endOf('month').valueOf(),
		];
	}

	public get selectedAgents() {
		return gdbx.allAgents;
	}

	public get selectedStockItems() {
		return gdbx.allStockItems.map((vt) => vt.value);
	}

	public get selectedCustomers() {
		return gdbx.allCustomers.map((vt) => vt.value);
	}

	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
